import { Component } from '@angular/core'

@Component({
  selector: 'cover-delete-payment-method',
  templateUrl: './delete-payment-method.component.html',
  styleUrls: ['./delete-payment-method.component.scss'],
})
export class DeletePaymentMethodComponent {}
